import { EventType } from "../../../../../constants";

export interface StopContactRow {
  contactId?: string;
  queueName?: string;
  initialContactId?: string;
  queueArn?: string;
  initiationTimestamp?: string;
  instanceId?: string;
  eventType?: string;
  initiationMethod?: string;
  ttlExpiryTime?: string | number;
  channel?: string;
  previousContactId?: string;
  status?: string;
  isChecked?: boolean;
  [key: string]: unknown;
}

interface ContactEventPayload {
  contactId?: string;
  queueName?: string;
  initialContactId?: string;
  queueArn?: string;
  initiationTimestamp?: string;
  instanceId?: string;
  eventType?: string;
  initiationMethod?: string;
  ttlExpiryTime?: string | number;
  channel?: string;
  previousContactId?: string;
  status?: string;
}

/**
 * Making sure data is sent to the backend with the expected attributes
 */
export const mapContactEvent = (data: StopContactRow): ContactEventPayload => {
  const contactEvent: ContactEventPayload = {
    contactId: data.contactId,
    queueName: data.queueName,
    initialContactId: data.initialContactId,
    queueArn: data.queueArn,
    initiationTimestamp: data.initiationTimestamp,
    instanceId: data.instanceId,
    eventType: data.eventType,
    initiationMethod: data.initiationMethod,
    ttlExpiryTime: data.ttlExpiryTime,
    channel: data.channel,
    previousContactId: data.previousContactId,
  };

  if (data.status) {
    contactEvent.status = data.status;
  }

  return contactEvent;
};

/**
 * Whether the given row contains a status/state that is considered invalid
 */
export const isInvalidRow = (row: StopContactRow): boolean => {
  return (
    row.eventType !== EventType.INITIATED ||
    row.status === EventType.STOPPED ||
    row.status === EventType.SUBMITTED
  );
};

/**
 * Returns the given className if the row is considered invalid
 */
export const calcRowClassName = (
  row: StopContactRow,
  className: string,
): string | undefined => {
  return isInvalidRow(row) ? className : undefined;
};
